module.exports = new __parcel__URL__("animals.d957d910.jpg").toString();